export default function Partners() {
  return (
    <section className="py-16 bg-gradient-to-b from-orange-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-2">
            We work with the best ...
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 items-center justify-items-center">
          <div className="flex items-center justify-center p-6 grayscale hover:grayscale-0 transition-all duration-300">
            <img
              src="https://instavisible.app/img/wordpress-logo.3eba492d.webp"
              alt="WordPress"
              className="h-16 w-auto object-contain"
            />
          </div>
          <div className="flex items-center justify-center p-6 grayscale hover:grayscale-0 transition-all duration-300">
            <img
              src="https://instavisible.app/img/shopify-logo.29cc0670.webp"
              alt="Shopify"
              className="h-16 w-auto object-contain"
            />
          </div>
          <div className="flex items-center justify-center p-6 grayscale hover:grayscale-0 transition-all duration-300">
            <img
              src="https://instavisible.app/img/squarespace-logo.ff7ffc79.webp"
              alt="Squarespace"
              className="h-16 w-auto object-contain"
            />
          </div>
          <div className="flex items-center justify-center p-6 grayscale hover:grayscale-0 transition-all duration-300">
            <img
              src="https://instavisible.app/img/clickfunnel-logo.f589a2b8.webp"
              alt="ClickFunnels"
              className="h-16 w-auto object-contain"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
